import { z } from "zod";

const workingHourSchema = z.object({
  dayOfWeek: z.string(),
  openingTime: z.string(),
  closingTime: z.string(),
  isClosed: z.boolean(),
});

const facilitySchema = z.object({
  id: z.number(),
  quantity: z.number(),
});

export const entityBranchSchema = z.object({
  countryId: z.number(),
  name: z.string({ required_error: "BRANCH_NAME_REQUIRED" }).min(1, "BRANCH_NAME_REQUIRED"),
  address: z.string({ required_error: "ADDRESS_REQUIRED" }).min(1, "ADDRESS_REQUIRED"),
  googleMapsLink: z
    .string({ required_error: "GOOGLE_MAPS_LINK_REQUIRED" })
    .url("GOOGLE_MAPS_LINK_INVALID")
    .min(1, "GOOGLE_MAPS_LINK_REQUIRED"),
  isHeadquarter: z.boolean(),
  facilities: z.array(facilitySchema),
  sports: z.array(z.number()),
  workingHours: z.array(workingHourSchema),
});
